import styles from 'typescript/apps/checkout_v3/components/page_title.module.scss';
import { HTMLAttributes } from 'react';

interface PageTitleProps extends HTMLAttributes<HTMLElement> {
  title: string;
  subtitle: string;
}

const PageTitle = ({ title, subtitle, className }: PageTitleProps) => {
  return (
    <h2 className={`${styles.title} ${className}`}>
      {title}
      <span> {subtitle}</span>
    </h2>
  );
};

export default PageTitle;
